// extracted by mini-css-extract-plugin
export default {"checkbox_label":"CheckboxLabel_checkbox_label__wjkHk","fadeInOut":"CheckboxLabel_fadeInOut__Vt2cJ"};